import type { ReactNode } from 'react'
import React from 'react'

import * as S from './ExplanationText.styled'

type Props = {
  title?: string
  subtitle?: ReactNode
}

export const ExplanationText = ({ title, subtitle }: Props) => {
  return (
    <S.Container>
      <S.Title>{title}</S.Title>
      {subtitle && <S.Subtitle>{subtitle}</S.Subtitle>}
    </S.Container>
  )
}
